import React from "react";
import { Survey } from "../../../amorg-common";
import { SurveyAnswerGraphData } from "../../../amorg-common/DTOs/SurveyAnswerGraphData";
import { getSurveyAnswerGraphData } from "../../../api/surveyClientApi";
import { Flex } from "../../../designSystem/compositeComponents/FlexHelpers";
import { DateInput } from "../../../designSystem/inputs/DateInput";
import * as dateMath from 'date-arithmetic';
import { AnswerGraph } from "../../surveys/AnswerGraph";
import { Label } from "../../../designSystem/Label";

type AnswerGraphPanelProps = {
    survey:Survey,
    triggerTimestamp:Date,
}
type AnswerGraphPanelState = {
    loading:boolean,
    graphStartDate:Date,
    graphData:SurveyAnswerGraphData|null
}
export function AnswerGraphPanel(props:AnswerGraphPanelProps):JSX.Element
{
    const [state,setState] = React.useState<AnswerGraphPanelState>({ 
        loading:true,
        graphStartDate:dateMath.add(new Date(), -6, 'day'),
        graphData:null
    });

    React.useEffect(()=>{
        reloadState(state.graphStartDate);
    },[props.triggerTimestamp])

    async function reloadState(startDate:Date) {
        if(props.survey){
            setState({...state, loading:true})
            setState({
                ...state,
                graphStartDate:startDate,
                graphData:await getSurveyAnswerGraphData(props.survey.id, startDate),
                loading:false
            });
        }
    }

    async function dateChanged(endDate:Date)
    {
        const startDate = dateMath.add(endDate, -6, 'day');
        setState({
            ...state,
            graphStartDate:startDate,
            graphData:await getSurveyAnswerGraphData(props.survey.id, startDate),
        })
    }


    const graphEndDate = dateMath.add(state.graphStartDate, 6, 'day');

    return (
        <div>
            <Flex flexDirection='column' gap={16}>
                <Flex flexDirection="row" justifyContent="space-between">
                    <Label>Antal gennemførte besvarelser over tid</Label>
                    <DateInput 
                        value={graphEndDate}
                        onValueChange={dateChanged}
                    />
                </Flex>

                <AnswerGraph data={state.graphData} />
            </Flex>
        </div>
    );
}